import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import {
//   ValidationRule,
//   CreateValidationRule,
//   UpdateValidationRule,
// } from 'store/admin/validationRules/types';

interface ValidationRulesState {
  isLoading: boolean;
  isCreateLoading: boolean;
  isUpdateLoading: boolean;
  isDeleteLoading: boolean;
  entities: any[] | null; // ValidationRule
  error: string | null;
}

const initialState: ValidationRulesState = {
  isLoading: false,
  isCreateLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  entities: null,
  error: null,
};

const validationRulesSlice = createSlice({
  name: 'validationRules',
  initialState,
  reducers: {
    // ===== GET LIST =====
    requestValidationRules(state) {
      state.isLoading = true;
      state.error = null;
    },
    getValidationRulesSuccess(
      state,
      { payload }: PayloadAction<any[]> // ValidationRule
    ) {
      state.isLoading = false;
      state.entities = payload;
    },
    getValidationRulesError(state, { payload }: PayloadAction<string>) {
      state.isLoading = false;
      state.error = payload;
    },

    // ===== CREATE =====
    requestCreateValidationRule(
      state,
      _action: PayloadAction<any> // CreateValidationRule
    ) {
      state.isCreateLoading = true;
    },
    createValidationRuleSuccess(
      state,
      { payload }: PayloadAction<any> // ValidationRule
    ) {
      state.isCreateLoading = false;
      state.entities = state.entities ? [...state.entities, payload] : [payload];
    },
    createValidationRuleError(state, { payload }: PayloadAction<string>) {
      state.isCreateLoading = false;
      state.error = payload;
    },

    // ===== UPDATE =====
    requestUpdateValidationRule(
      state,
      _action: PayloadAction<any> // UpdateValidationRule
    ) {
      state.isUpdateLoading = true;
    },
    updateValidationRuleSuccess(
      state,
      { payload }: PayloadAction<any> // ValidationRule
    ) {
      state.isUpdateLoading = false;
      state.entities = state.entities?.map((rule) => (rule.key === payload.key ? payload : rule)) ?? null;
    },
    updateValidationRuleError(state, { payload }: PayloadAction<string>) {
      state.isUpdateLoading = false;
      state.error = payload;
    },

    // ===== DELETE =====
    requestDeleteValidationRule(state, _action: PayloadAction<{ key: string }>) {
      state.isDeleteLoading = true;
    },
    deleteValidationRuleSuccess(state, { payload }: PayloadAction<{ key: string }>) {
      state.isDeleteLoading = false;
      state.entities = state.entities?.filter((rule) => rule.key !== payload.key) ?? null;
    },
    deleteValidationRuleError(state, { payload }: PayloadAction<string>) {
      state.isDeleteLoading = false;
      state.error = payload;
    },
  },
});

export const {
  requestValidationRules,
  getValidationRulesSuccess,
  getValidationRulesError,

  requestCreateValidationRule,
  createValidationRuleSuccess,
  createValidationRuleError,

  requestUpdateValidationRule,
  updateValidationRuleSuccess,
  updateValidationRuleError,

  requestDeleteValidationRule,
  deleteValidationRuleSuccess,
  deleteValidationRuleError,
} = validationRulesSlice.actions;

export default validationRulesSlice.reducer;
